import type { ResourceScope } from 'src/types/global'
import { useFetch } from '@gluedigital/ruse-fetch-extras'
import { QUERY_BUILDER_URL } from 'src/constants/global'
import { QueryListItem } from 'src/types/queries'

export interface QueryListResponse {
  queries: QueryListItem[]
}

export const useQueryListData = (scope: ResourceScope): QueryListItem[] => {
  const { queries } = useFetch<QueryListResponse>(
    QUERY_BUILDER_URL + '/queries/' + scope
  )
  return queries
}
